interface PriceRow {
  service: string;
  price: string;
  note?: string;
}

interface PriceTableProps {
  rows: PriceRow[];
  compact?: boolean;
}

export default function PriceTable({ rows, compact = false }: PriceTableProps) {
  return (
    <div className="w-full overflow-hidden rounded-xl border border-background-300/60">
      <table className="w-full text-left">
        <thead>
          <tr className="bg-primary-500">
            <th className={`${compact ? 'px-4 py-3' : 'px-6 py-4'} text-white font-heading font-bold text-sm md:text-base`}>
              Intervention
            </th>
            <th className={`${compact ? 'px-4 py-3' : 'px-6 py-4'} text-white font-heading font-bold text-sm md:text-base text-right`}>
              À partir de
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr
              key={row.service}
              className={`${index % 2 === 0 ? 'bg-background-100' : 'bg-white'} transition-colors hover:bg-background-200/70`}
            >
              <td className={`${compact ? 'px-4 py-3' : 'px-6 py-4'} text-foreground-800 text-sm md:text-base`}>
                {row.service}
                {row.note && (
                  <span className="block text-foreground-500 text-xs mt-0.5">{row.note}</span>
                )}
              </td>
              <td className={`${compact ? 'px-4 py-3' : 'px-6 py-4'} text-foreground-950 font-bold text-sm md:text-base text-right whitespace-nowrap`}>
                {row.price}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}